export default __webpack_public_path__ + "static/media/return-node.4e1c9fa1.svg";